import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "registration-form" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 mb-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-red-500" }, "*", -1)
const _hoisted_4 = {
  key: 1,
  class: "hidden",
  "data-testid": "occupation"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "Must be 8-32 characters long", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, "Include at least one lowercase letter", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, "Include at least one uppercase letter", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, "Include at least one number", -1)
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 5,
  class: "mb-4 font-bold text-sm"
}
const _hoisted_11 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormError = _resolveComponent("FormError")!
  const _component_FormErrorInline = _resolveComponent("FormErrorInline")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InputReadOnly = _resolveComponent("InputReadOnly")!
  const _component_InputFileField = _resolveComponent("InputFileField")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_snap_button = _resolveComponent("snap-button")!
  const _directive_autofocus = _resolveDirective("autofocus")!
  const _directive_keyboard_submit = _resolveDirective("keyboard-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" Indicates a required field. ")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createBlock(_component_FormError, {
          key: 1,
          error: _ctx.error,
          class: "mb-6 sticky top-8 inset-x-8 z-20"
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    (_ctx.featureOn?.('USER-888-new-sign-up-view'))
      ? (_openBlock(), _createBlock(_component_FormErrorInline, {
          key: 2,
          error: _ctx.error,
          class: "mb-4"
        }, null, 8, ["error"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.signup()), ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(
          _ctx.featureOn?.('USER-888-new-sign-up-view') ? ['flex', 'gap-4'] : []
        )
      }, [
        _withDirectives(_createVNode(_component_InputField, {
          class: "flex-grow mb-4",
          label: "First Name",
          type: "text",
          modelValue: _ctx.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
          validation: _ctx.v$.firstName,
          "data-testid": "first_name",
          required: ""
        }, null, 8, ["modelValue", "validation"]), [
          [_directive_autofocus]
        ]),
        _createVNode(_component_InputField, {
          class: "flex-grow mb-4",
          label: "Last Name",
          name: "lastName",
          type: "text",
          modelValue: _ctx.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
          validation: _ctx.v$.lastName,
          "data-testid": "last_name",
          required: ""
        }, null, 8, ["modelValue", "validation"])
      ], 2),
      (_ctx.useRoleSelector && !_ctx.isLocked('occupation'))
        ? (_openBlock(), _createBlock(_component_Select, {
            key: 0,
            class: "mb-4",
            label: "Tell Us About Yourself",
            placeholder: "Select Your Role",
            modalTitle: "Select Your Role",
            modelValue: _ctx.occupation,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.occupation) = $event)),
            options: _ctx.SignUpOccupations,
            validation: _ctx.v$.occupation,
            "data-testid": "occupation",
            required: ""
          }, null, 8, ["modelValue", "options", "validation"]))
        : _createCommentVNode("", true),
      (_ctx.useRoleSelector && _ctx.isLocked('occupation'))
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.occupation), 1))
        : _createCommentVNode("", true),
      (!_ctx.isLocked('email'))
        ? (_openBlock(), _createBlock(_component_InputField, {
            key: 2,
            class: "mb-4",
            label: "Email Address",
            name: "email",
            type: "email",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
            validation: _ctx.v$.email,
            "data-testid": "email",
            required: ""
          }, null, 8, ["modelValue", "validation"]))
        : _createCommentVNode("", true),
      (_ctx.isLocked('email'))
        ? (_openBlock(), _createBlock(_component_InputReadOnly, {
            key: 3,
            class: "mb-4",
            label: "Email",
            value: _ctx.email,
            required: ""
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_InputField, {
        class: "mb-4",
        label: "Mobile Number",
        name: "phoneNumber",
        type: "text",
        modelValue: _ctx.phoneNumber,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneNumber) = $event)),
        validation: _ctx.v$.phoneNumber,
        "data-testid": "phone_number",
        required: ""
      }, null, 8, ["modelValue", "validation"]),
      _createVNode(_component_InputField, {
        label: "Password",
        name: "password",
        type: "password",
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
        validation: _ctx.v$.password,
        "data-testid": "password",
        required: ""
      }, null, 8, ["modelValue", "validation"]),
      _createElementVNode("ul", {
        class: _normalizeClass(["text-sm mt-1 mb-4 list-disc pl-4", _ctx.v$.password.$invalid ? ['text-red-600'] : ['text-gray-500']])
      }, _hoisted_9, 2),
      _createVNode(_component_InputField, {
        class: "mb-4",
        label: "Confirm Password",
        name: "password",
        type: "password",
        modelValue: _ctx.confirmPassword,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmPassword) = $event)),
        validation: _ctx.v$.confirmPassword,
        "data-testid": "confirm_password",
        required: ""
      }, null, 8, ["modelValue", "validation"]),
      (_ctx.useProfilePicture)
        ? (_openBlock(), _createBlock(_component_InputFileField, {
            key: 4,
            class: "mb-4",
            label: "Profile Picture",
            accept: "image/*",
            "corner-hint": _ctx.profilePictureHint,
            modelValue: _ctx.profilePicture,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profilePicture) = $event)),
            "data-testid": "profile_picture"
          }, null, 8, ["corner-hint", "modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.featureOn?.('USER-888-new-sign-up-view'))
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " We’ll send you a verification code to complete your sign up, please check you’ve correctly entered your mobile number and email. "))
        : _createCommentVNode("", true),
      (_ctx.featureOn?.('USER-888-new-sign-up-view'))
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 6,
            type: "warning",
            border: "false",
            close: "false",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" We’ll send you a verification code to complete your sign up, please check you’ve correctly entered your mobile number and email. ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_snap_button, {
          "button-type": "submit",
          disabled: _ctx.state$.is('SUBMITTING'),
          shape: "circular",
          size: "lg",
          variant: "primary",
          "data-testid": "sign_up"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create Account ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32)), [
      [_directive_keyboard_submit]
    ])
  ]))
}